<div class="card">
  <div class="card-header">
    <div class="container">
      <div class="row">
        <div class="col-9 text-left">
          <h5>ePreop Patient Experience</h5>
        </div>
        <div class="col-3 text-right">
          <img src="assets/images/ePreopLogo.png" class="header-logo" alt="ePreop"/>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="container">
      @if (surveyModel) {
        <survey [model]="surveyModel"></survey>
      } @else {
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h5 class="card-title">Welcome to ePreop's Patient Experience survey.</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="card-text">
                Your Healthcare Provider would like you to take the following brief survey; it will only take a few
                minutes. By participating, you will help ensure patients can receive the highest possible quality of care.
              </p>
            </div>
          </div>
        </div>
        <hr />
        <br />
        @if (surveyCompleted()) {
          <h2>
            <span style="color:#149BD5;" class="glyphicon glyphicon-send"></span>&nbsp;&nbsp;It appears that you've already
            completed your survey.
            <br />
            <br />
            Thank you for your feedback.
          </h2>
        } @else if (errorMsg()) {
          <br />
          <h2>Sorry, Survey Could Not Be Found</h2>
          <i>Return Message: {{ errorMsg() }}</i>
        } @else {
          <h2>Survey Loading...</h2>
          <i>Message 598.34</i>
          <!-- This is the initial loading messages for the page.  If the user is seeing this, then there is something wrong with the API call -->
        }
      }
    </div>
  </div>
  <div class="card-footer">
    <div class="container">
      <div class="row">
        <div class="col text-right">
          v3.20260802
        </div>
      </div>
    </div>
  </div>
</div>